import { Box, Link, Stack, Text, Flex, Image } from "@chakra-ui/react";
import { ActivePatientIcon } from "assets/svg/ActivePatientIcon";
import { AppointmentIcon } from "assets/svg/AppointmentIcon";
import { CategoriesIcon } from "assets/svg/CategoriesIcon";
import { FamilyCardIcon } from "assets/svg/FamilyCardIcon";
import { ServicesIcon } from "assets/svg/ServicesIcon";
import { TestsIcon } from "assets/svg/TestsIcon";
import { TransactionIcon } from "assets/svg/TransactionIcon";
import React from "react";
import { FaStar } from "react-icons/fa";
import { Link as RouteLink, useLocation } from "react-router-dom";
import logoWithName from "../../assets/logo_with_name.png";

const sidebarItems = [
  {
    icon: <ActivePatientIcon />,
    name: "Active Patients",
    route: "/patients",
  },
  {
    icon: <AppointmentIcon />,
    name: "Appointments",
    route: "/appointments",
  },
  {
    icon: <TestsIcon />,
    name: "Tests",
    route: "/tests",
  },
  {
    icon: <TransactionIcon />,
    name: "Transactions",
    route: "/transactions",
  },
  {
    icon: <CategoriesIcon />,
    name: "Categories",
    route: "/categories",
  },
  {
    icon: <ServicesIcon />,
    name: "Services",
    route: "/services",
  },
  {
    icon: <FamilyCardIcon />,
    name: "Discount Card",
    route: "/discountcards",
  },
  {
    icon: <FaStar />,
    name: "Reviews",
    route: "/reviews",
  },
];

export default function Sidebar() {
  const match = useLocation();

  return (
    <Box minW="240px" w="240px">
      <Flex height={32} justify="center">
        <Flex justify="center" align="flex-start" padding="8">
          <Image src={logoWithName} width={160} />
          <Text
            bg="accent.500"
            color="white"
            padding="0px 6px"
            fontSize="xs"
            fontWeight="500"
            borderRadius="24px"
          >
            Lab
          </Text>
        </Flex>
      </Flex>
      <Stack spacing={6}>
        {sidebarItems.map(({ icon, name, route }) => {
          const currentRoute = match.pathname === route;
          return (
            <Link
              as={RouteLink}
              key={route}
              to={route}
              px={8}
              py={3}
              _focus={{ outline: "none" }}
              position="relative"
            >
              {currentRoute && (
                <Box
                  position="absolute"
                  w="3px"
                  h="100%"
                  left="0"
                  top="0"
                  bg="#000"
                  borderRadius="0px 7px 7px 0"
                />
              )}
              <Stack
                direction="row"
                spacing={4}
                alignItems="center"
                color={currentRoute ? "black" : "gray.500"}
              >
                {icon}
                <Text fontWeight="500">{name}</Text>
              </Stack>
            </Link>
          );
        })}
      </Stack>
    </Box>
  );
}
